"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const generateApolloSdkConfig = {
    documents: "./**/*.graphql",
    plugins: [
        {
            add: {
                content: "/* eslint-disable */\n// @ts-nocheck",
            },
        },
        "typescript-operations",
        "fragment-matcher",
        "typescript-generic-sdk",
    ],
    config: {
        gqlImport: "graphql-tag",
        skipTypename: true,
        withResultType: true,
        withMutationOptionsType: false,
        nameSuffix: "Type",
        operationResultSuffix: "OperationResult",
        reactApolloVersion: 3,
        avoidOptionals: false,
        maybeValue: "T | null",
    },
    preset: "import-types",
    presetConfig: {
        typesPath: "./graphql-types",
    },
};
exports.default = generateApolloSdkConfig;
//# sourceMappingURL=generate-apollo-sdk-config.js.map